<template>
  <el-select
    v-bind="$attrs"
    @input="$emit('input', $event)"
    :clearable="clearable"
    size="mini"
    filterable 
  >
    <el-option
      v-for="(item,i) in optionData"
      :key="i+'enumsSelect'"
      :label="item[label]"
      :value="id==='Object'?item:item[id]"
    ></el-option>
  </el-select>
</template>

<script>
// import enums from '@/api/enums'

export default {
  props: {
    enumName: String,
    options:{
      type:Array,
      default:undefined
    },
    clearable:{
      default:true
    },
    label:{
      default:'label'
    },
    id:{
      default:'value'
    }
  },
  mounted() {
      this.optionData=this.options//||enums[this.enumName]
  },
  data() {
    return {
      optionData: []
    }
  }
}
</script>
